export const comMenus = (logoUrl) => ({
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
            href: '/en/',
            url: logoUrl,
            alt: 'Raisin',
        },
    ],
    navItems: [],
    actionItems: [],
});
//# sourceMappingURL=comMenus.js.map